import React from "react";
import PropTypes from "prop-types";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { countryList } from "../../../data/countryList";

const { Option } = Select;
const FilterForm = ({ onSearch, onReset, form, classes }) => {
  const countryListMenu = countryList.map((country) => (
    <Option value={country.name}>{country.name}</Option>
  ));

  return (
    <Form form={form} onFinish={onSearch}>
      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="param" rules={[{ required: false }]}>
            <Select placeholder="Search by...">
              <Option value="firstName">First Name</Option>
              <Option value="lastName">Last Name</Option>
              <Option value="email">Email</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="val" rules={[{ required: false }]}>
            <Input placeholder="Enter the search term..." />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: false, message: "Please select Country!" }]}
          >
            <Select placeholder="Select a country">{countryListMenu}</Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Class Code" name="classCode">
            {classes ? (
                <Select
                    options={classes}
                    placeholder={"Select Class Code"}
                    mode="multiple"
                    notFoundContent={null}
                />
            ) : null}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[{ required: false, message: "Please input start date!" }]}
          >
            <DatePicker showTime={false} showNow={false} />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[{ required: false, message: "Please input end date!" }]}
          >
            <DatePicker showTime={false} showNow={false} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
};

FilterForm.propTypes = {
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
};

export default FilterForm;
